// ==========================================
// src/components/LanguageSelector.jsx
// ==========================================

import React from 'react';
import { Languages } from 'lucide-react';
import { LANGUAGE_OPTIONS } from '../i18n/translations';

/**
 * COMPONENTE REUTILIZÁVEL DE SELEÇÃO DE IDIOMA
 * 
 * @param {string} selectedLanguage - Código do idioma atual (ex: 'en', 'pt')
 * @param {function} onLanguageChange - Callback chamado quando idioma muda
 * @param {string} title - Título do seletor (opcional)
 * @param {string} description - Descrição do seletor (opcional)
 */
const LanguageSelector = ({ 
  selectedLanguage, 
  onLanguageChange,
  title = "Idioma da página",
  description = "Ao selecionar um idioma, os textos padrão (cookies, botões, disclosure) serão traduzidos automaticamente."
}) => {
  return (
    <div className="mb-4 rounded-xl border border-blue-200 bg-blue-50 p-4 dark:border-blue-900 dark:bg-blue-950/40">
      <div className="mb-3 flex items-center gap-2">
        <Languages size={18} className="text-blue-700 dark:text-blue-400" />
        <h3 className="text-sm font-semibold text-blue-900 dark:text-blue-300">
          {title}
        </h3>
      </div>
      
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-6">
        {LANGUAGE_OPTIONS.map((lang) => (
          <button
            key={lang.code}
            type="button"
            onClick={() => onLanguageChange(lang.code)}
            className={`flex flex-col items-center gap-1 rounded-xl border-2 px-3 py-2.5 text-center transition ${
              selectedLanguage === lang.code
                ? "border-blue-600 bg-blue-100 dark:border-blue-400 dark:bg-blue-950/60"
                : "border-slate-200 bg-white hover:border-blue-300 dark:border-slate-700 dark:bg-slate-900"
            }`}
          >
            <span className="text-2xl">{lang.flag}</span>
            <span className="text-xs font-medium text-slate-700 dark:text-slate-300">
              {lang.name}
            </span>
          </button>
        ))}
      </div>
      
      <p className="mt-3 text-xs text-blue-700 dark:text-blue-400">
        💡 {description}
      </p>
    </div>
  );
};

export default LanguageSelector;